/*
 * @Author: chen cs
 * @Date: 2020-02-20 15:51:57
 * @LastEditors: chen cs
 * @LastEditTime: 2020-02-22 22:15:37
 * @Description: file content
 */
import SpaceService from '@/assets/service/space'
import { typeOf } from '@zjy/zjy-ui/lib/utils/dom'
import { capitalize } from '@/assets/utils'
import queryString from 'querystring'
import { getCookie } from '@/assets/utils/CommonUtil'
import { backendUrl } from '@/assets/js/config'
export default {
  methods: {
    /**
     * @description:
     * @param String action
     * @param Object item
     * @return: Promise || undefined
     */
    shareFileActionEmitter (action, item) {
      if (action && item) {
        switch (action) {
          case 'preview': // 预览
            let query = queryString.stringify({shareToken: item.shareToken, jsonToken: item.jsonToken, fileId: item.fileId, fileType: item.fileType, fileName: item.fileName})
            const canPreviewSuffix = ['gtj', 'gbq5', 'gbq6', 'gbq7','gbq6jy', 'gbq6xs'] // 能预览的文件后缀 不区分大小写
            if (typeOf(item) === 'Object' && item.fileName) {
              // 失效文件不能预览;  item.isEncrypt === 1 加密文件不能预览
              if (this.isInvalid(item) || +item.isEncrypt === 1) { return }
              const matchedArr = /[^.]+\.([a-z0-9]+)$/i.exec(item.fileName)
              if (matchedArr && matchedArr[1]) {
                const nowSuffix = capitalize(matchedArr[1], true, true)
                if (canPreviewSuffix.indexOf(nowSuffix) > -1) {
                  // 当前文件可预览
                  switch (nowSuffix) {
                    // case 'gtj': // 预览分享的 GTJ
                    //   window.open(`/#/preview/gtj?${query}`, "_blank");
                    //   break
                    case 'gbq5': // 预览分享的 GBQ5
                    case 'gbq6': // 预览分享的 GBQ6
                    case 'gbq7': // 预览分享的 GBQ6
                    case 'gbq6jy': // 预览分享的 GBQ6
                    case 'gbq6xs': // 预览分享的 GBQ6
                      window.open(`/#/preview/gbq5?${query}`, '_blank')
                      break
                    default:
                  }
                }
              }
            }
            break
          case 'download': // 下载
            if (typeOf(item) === 'Object') {
              if (this.isInvalid(item)) { return }
              const params = {
                shareToken: item.shareToken,
                token: getCookie('ZJYTOKEN')
              }
              window.common.downloadFile(`${backendUrl}/share/file/download?${queryString.stringify(params)}`)
            }
            break
          case 'delete': // 删除
            let params = {}
            if (typeOf(item) === 'Array') {
              params.shareIds = item.map((child) => child.shareId)
            } else if (typeOf(item) === 'Object') {
              params.shareIds = [item.shareId]
            }
            return SpaceService.deleteShareFile(params)
            // break
          case 'unloading': // 转存到我的空间
            if (typeOf(item) === 'Object') {
              if (this.isInvalid(item)) { return }
              const params = {
                shareId: item.shareId,
                targetWsId: getCookie('personalWorkspaceIdValue')
              }
              return SpaceService.saveShareFile(params)
            }
            break
          default:
        }
      } else {
        console.log('调用参数缺失!')
      }
    },
    // 2. 文件是否是无效的 (在分享的有效期内)
    isInvalid (item) {
      let valid = true
      if (item.remainTime === null || +item.remainTime > 0) {
        valid = false
      }
      return valid
    }
  }
}
